<script>
  export default {
    props: {
      isHomeProducts: {
        type: Boolean,
        default: false,
      },
      list: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    data() {
      return {
        activeMenu: 0,
        // productsActiveName: '',
      }
    },
    computed: {
      currentProducts() {
        return this.list[this.activeMenu].products
      },
      formattedMenu() {
        return this.list.map((item) => ({
          title: item.product_category_title,
          alias: item.product_category_alias,
          // to: {
          //   name: 'brand-product-item',
          //   params: {
          //     productAlias: item.alias,
          //   },
          // }
        }))
      },
      goToProducts() {
        // this.productsActiveName = this.list[this.activeMenu].product_category_alias
        return {
          name: 'brand-product-list',
          params: {
            brandAlias: this.$route.params.brandAlias
          },
          query: {
            filterCategory: this.list[this.activeMenu].product_category_alias
          }
        }
      }
    },
    methods: {
      goToProduct(alias) {
        return {
          name: 'brand-product-item',
          params: {
            productAlias: alias,
          },
        }
      },

    }
  }
</script>
<template>
  <div :class="$style.VerticalNavBox">
    <template v-if="isHomeProducts">
      <div class="VerticalNavBox__nav">
        <BaseMenu
          v-model="activeMenu"
          is-product-nav
          :list="formattedMenu"
          type="holderHover"
          class="d-none d-lg-block VerticalNavBox__menu"
        />
        <div class="d-block d-lg-none">
          <el-select
            v-model="activeMenu"
            class="isStyleMenu isCenter"
            popper-class="isStyleMenu isCenter"
          >
            <el-option
              v-for="(item, index) in list"
              :key="item.product_category_alias"
              :label="item.product_category_title"
              :value="index">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="VerticalNavBox__right">
        <div class="VerticalNavBox__content homeProducts">
          <el-tabs v-model="productsActiveName" class="isStyleBase" stretch>
            <el-tab-pane label="依提供品牌" name="first">
              <ul class="VerticalNavBox__list row">
                <!-- <li v-for="(item, index) in currentProducts"  :key="index" class="VerticalNavBox__item col-md-6"> -->
                <!--<router-link class="VerticalNavBox__link" :to="item.to"> {{ item.text }}</router-link>-->
                <!-- <BaseButton
                  :to="item.to"
                  class="megaMenu__menuList__link isText isRadius isSmall isFull"
                >
                  {{ item.text }}
                </BaseButton>
              </li> -->
              </ul>
            </el-tab-pane>
            <el-tab-pane label="依產品分類" name="second">
              <ul class="VerticalNavBox__list row">
                <!-- <li v-for="(item, index) in currentProducts" :key="index" class="VerticalNavBox__item col-md-6"> -->
                <!--<router-link class="VerticalNavBox__link" :to="item.to"> {{ item.text }}</router-link>-->
                <!-- <BaseButton
                  :to="item.to"
                  class="megaMenu__menuList__link isText isRadius isSmall isFull"
                >
                  {{ item.text }}
                </BaseButton>
              </li> -->
              </ul>
            </el-tab-pane>
          </el-tabs>
        </div>
        <router-link
          class="VerticalNavBox__btn"
          :to="{ name: 'brand-list', params: { brandAlias: 'test' } }"
        >
          查看更多品牌 <span class="VerticalNavBox__btn__icon"><i class="fal fa-angle-right"></i></span
        ></router-link>
      </div>
    </template>
    <template v-else>
      <div class="VerticalNavBox__nav isStyleBrandProduct">
        <BaseMenu
          v-model="activeMenu"
          is-product-nav
          :list="formattedMenu"
          type="holderHover"
          class="d-none d-lg-block VerticalNavBox__menu"
        />
        <div class="d-block d-lg-none">
          <el-select
            v-model="activeMenu"
            class="isStyleMenu isCenter"
            popper-class="isStyleMenu isCenter"
          >
            <el-option
              v-for="(item, index) in list"
              :key="item.product_category_alias"
              :label="item.product_category_title"
              :value="index">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="VerticalNavBox__right">
        <div class="VerticalNavBox__content">
          <h3 class="VerticalNavBox__title--base">
            產品總覽
          </h3>
          <ul class="VerticalNavBox__list row">
            <li v-for="(item, index) in currentProducts" :key="index" class="VerticalNavBox__item col-md-6">
              <!--<router-link class="VerticalNavBox__link" :to="item.to"> {{ item.text }} </router-link>-->
              <BaseButton
                :to="goToProduct(item.alias)"
                class="megaMenu__menuList__link isStyleDark isText isSmall isFull VerticalNavBox__item__title"
              >
                {{ item.title }}
              </BaseButton>
            </li>
          </ul>
        </div>
        <router-link class="VerticalNavBox__btn" :to="goToProducts">
          查看更多產品 <span class="VerticalNavBox__btn__icon"><i class="fal fa-angle-right"></i></span
        ></router-link>
      </div>
    </template>
  </div>
</template>
<style lang="scss" module>
  .VerticalNavBox {
    display: flex;
    margin-bottom: 3.75rem;
    // background: #fff;
    @include max-lg {
      display: flex;
      flex-direction: column;
    }

    :global {
      .VerticalNavBox {
        &__title--base {
          position: relative;
          display: inline-block;
          // margin-left: 1.125rem;
          margin-top: 1.6rem;
          margin-bottom: 3.6rem;
          font-size: 1.125rem;

          &::before {
            position: absolute;
            right: 0;
            bottom: -20px;
            left: 0;
            width: 100%;
            height: 5px;
            content: "";
            background-color: #ABCD03;
            border-radius: 4px;
          }

          // &::after {
          //   position: absolute;
          //   bottom: -20px;
          //   left: 10px;
          //   width: 5px;
          //   height: 5px;
          //   content: "";
          //   background-color: #ABCD03;
          //   border-radius: 50%;
          //   box-shadow: -9px 0 0 #ABCD03;
          // }
        }

        &__nav {
          width: 25%;
          min-width: 333px;
          padding: 1.5rem 0;
          background: #FFF;
          overflow: auto;
          @include max-xl {
            min-width: 255px;
          }

          @include max-lg {
            width: 100%;
            padding: 0;
            margin-bottom: 2rem;
          }
        }

        &__menu {
          // max-height: 538px;
          // overflow: auto;
        }

        &__right {
          display: flex;
          width: 75%;

          @include max-lg {
            flex-direction: column;
            width: 100%;
          }
        }

        &__content {
          flex: 1;
          // height: 586px;
          padding: 2.5rem 6rem;
          overflow: auto;
          background-color: $color-gray-2;

          @include max-xl {
            padding: 2.5rem 2rem;
          }
        }

        &__btn {
          display: flex;
          flex-basis: 100px;
          align-items: center;
          justify-content: center;
          color: $color-gray-5;
          text-decoration: none;
          letter-spacing: 13px;
          background-color: $color-gray-3;
          writing-mode: vertical-lr;
          transition: color 0.3s, background 0.3s;

          @include max-lg {
            flex-basis: 80px;
            letter-spacing: 0.2em;
            writing-mode: initial;
          }

          @include max-md {
            flex-basis: 54px;
            font-size: 1rem;
          }

          &:hover {
            color: $color-gray-7;
            text-decoration: none;
            background: $color-gray-4;

            .VerticalNavBox__btn__icon {
              color: $color-gray-7;
              border-color: $color-gray-7
            }
          }

          &__icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            margin-top: 0.7rem;
            font-size: 1rem;
            font-size: 1rem;
            border: 1px solid $color-gray-5;
            border-radius: 50%;
            transition: border 0.3s;

            @include max-lg {
              padding-left: 4px;
              margin-top: 0;
              margin-left: 1rem;
            }

            i {
              display: block;
              height: 1rem;
            }
          }

          // width: 15%;
        }

        &__list {
          padding: 0;
          margin: 0;
          margin: -0.75rem -1.25rem;
          list-style: none;

          @include max-xl {
            margin: -0.75rem;
          }

          .VerticalNavBox__item {
            @include max-md {
              &:nth-child(n + 6) {
                display: none;
              }
            }
          }
        }

        &__item {
          padding: 0.75rem 1.25rem;
          color: $color-gray-6;

          &:hover {
            color: $color-gray-7
          }

          @include max-xl {
            padding: 0.75rem 0.75rem;
            .megaMenu__menuList__link {
              letter-spacing: 0.1em;
            }
          }
          &__title {
            white-space: normal;
            text-align: left;
            letter-spacing: 0;
            border-radius: 5px;
            &:hover {
              &:not(:disabled) {
                background: #E8EAEE;
                border-bottom: 1px solid transparent;
              }
            }
          }
        }

        &__link {
          /* display: block;
          padding: 1rem 0;
          color: $color-gray-6;
          cursor: pointer;
          &:hover {
            color: $color-primary;
            text-decoration: none;
          } */
        }

        .baseMenu__link {
          padding: 1.5rem 0 1.5rem 3rem;
        }
      }

      .isStyleBase {
        .el-tabs__item {
          padding-bottom: 0.8rem;
          font-size: 1.125rem;
        }

        .el-tabs__active-bar {
          background: $color-primary;
        }
      }
    }
  }
</style>
